<template>
  <div class="blog-detail service-portlet">
    <div class="container">
      <div class="blog-listing">
        <!-- Content Area -->

        <article class="type-post">
          <!--<div class="entry-cover">-->
          <!--<img src="static/images/blog/1/1.png">-->
          <!--</div>-->
          <div class="blog-detail-contentbox">
            <h3>동영상 제작 어플리케이션 스냅무비 다운로드 500만명 돌파</h3>
            <p class="post-date"><span class="font-color-afblue">Posted at </span>12.13, 2016</p>
            <div class="contentbox-body">
              <div class="imagebox">
                <img src="static/images/blog/3/3.png">
              </div>
              <p>
                레나소프트웨어에서 개발한 동영상 촬영 어플리케이션이 매출순위와 앱 다운로드 순위에서 모두 1위를 차지하는 등 인기 상한가를 달리고 있습니다.
              </p>
              <p>
                영예의 어플리케이션은 코리아텍 졸업생들인 권병천(컴퓨터공학부. 99학번), 심진웅( 〃 04학번), 김지훈( 〃 06학번), 박아름(디자인공학과, 07학번)씨로 구성된
                ㈜레나소프트웨어(2010년 설립)가 지난 2월 만든 '스냅무비(로드무비 메이커)'입니다.

              </p>
              <p>
                이 어플리케이션은 3월부터 안드로이드폰 어플 시장(플레이스토어-사진 카테고리)에서 '최고매출' 1위와 '인기무료(다운로드)'
                1위를 각각 기록하고 있으며, 현재 다운로드 횟수가 무려 500만 건에 도달하였습니다.
              </p>
              <p>
                스냅무비 어플리케이션은 누구나 스마트폰에서 다운로드 받아 쉽게 무료로 이용할 수 있는
                무비 메이커(Movie maker-영상 촬영 및 편집)로서, 각 샷(shot)의 시간과 화면 비율을 지정할 수 있고, 영상 효과 필터, 음악 삽입, 공유 등이 가능합니다.
              </p>
            </div>
          </div>
          <div class="tags">
            <!--<h3 class="block-title">homepage : </h3>-->
            <!--<a href="http://www.lunchstar.co.kr/" target="_blank" >www.lunchstar.co.kr</a>-->
          </div>

        </article>

        <!-- Related Post -->
        <div class="related-post">
          <h3 class="block-title">recent blog</h3>
          <div class="row">
            <div class="row-3">
              <article class="type-post">
                <div class="entry-cover">
                  <a title="Cover" v-on:click="goBlogDetail(1)"><img src="static/images/blog/1/1.png"></a>
                </div>
                <div class="entry-contentbox">
                  <div class="entry-title">
                    <a title="Single post with image" v-on:click="goBlogDetail(1)"><h3>식당 고객  만족도 조사 서비스 런치스타 출시</h3></a>
                  </div>
                  <p class="post-date"><span class="font-color-afblue">Posted at </span>06.30, 2018</p>
                </div>
              </article>
            </div>
            <div class="row-3">
              <article class="type-post">
                <div class="entry-cover">
                  <a title="Cover" v-on:click="goBlogDetail(2)"><img src="static/images/blog/2/2.png"></a>
                </div>
                <div class="entry-contentbox">
                  <div class="entry-title">
                    <a title="Single post with image" v-on:click="goBlogDetail(2)"><h3>i-award smart app award 건강/의료분야  대상 수상</h3></a>
                  </div>
                  <p class="post-date"><span class="font-color-afblue">Posted at </span>12.07, 2017</p>
                </div>
              </article>
            </div>
            <!--<div class="row-3">-->
            <!--<article class="type-post">-->
            <!--<div class="entry-cover">-->
            <!--<a title="Cover" href="blog_detai_3.html"><img src="static/images/blog/3/3.png"></a>-->
            <!--</div>-->
            <!--<div class="entry-contentbox">-->
            <!--<div class="entry-title">-->
            <!--<a title="Single post with image" href="blog_detai_3.html"><h3>영상 제작 어플리케이션 스냅무비 다운로드-->
            <!--500만명 돌파</h3></a>-->
            <!--</div>-->
            <!--<p class="post-date"><span class="font-color-afblue">Posted at </span>12.13, 2016</p>-->
            <!--</div>-->
            <!--</article>-->
            <!--</div>-->

          </div>
        </div><!-- Related Post /- -->
      </div><!-- Content Area /- -->

    </div>
  </div><!-- Blog /- -->
</template>

<script>
  export default {
    name: 'Blog3',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    methods: {
      goBlogDetail( no ) {
        this.$router.push("Blog"+ no )
        //console.log('## click menu : ' + title)
        //this.menuVisible = false
        //this.$emit('clicked',title)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Blog3.vue